import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'src/components/shared/Button'
import { getGigsafeUserInviting } from 'src/selectors/gigsafeUser'

interface Props {
  formId: string
}

/**
 * The modal footer's submit. `CommonModal` portals the footer out of the `<Form>` element, so the
 * button submits by `form` id rather than by being inside it.
 */
const InviteGigsafeUserSubmitButtonComponent = ({ formId }: Props) => {
  const isInviting = useSelector(getGigsafeUserInviting)

  return (
    <Button
      size="small"
      color="dark"
      type="submit"
      form={formId}
      loading={isInviting}
      disabled={isInviting}
      data-testid="invite-gigsafe-user-submit-button"
    >
      Send invite
    </Button>
  )
}

export const InviteGigsafeUserSubmitButton = memo(InviteGigsafeUserSubmitButtonComponent)
